import React from 'react';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import EvaluatorSearchParams from './EvaluatorSearchParams';
import EvaluatorService from '../../../Services/EvaluatorService';
import ShownOverWindowsEnum from '../../../Enums/ShownOverWindowsEnum';
import EvaluatorItem from './EvaluatorItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import EvaluatorWindowDescription from './EvaluatorWindowDescription';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import ShowTipaltiEvaluatorDataWindow from './ShowTipaltiEvaluatorDataWindow';
import ShowAssignmentListOverDataWindow from './ShowAssignmentListOverDataWindow';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ShowEvaluatorPaymentsOverDataWindow from './EvaluatorPayments/ShowEvaluatorPaymentsOverDataWindow';
import ForceEvaluatorUploadToTpInstanceWindowDescription from './ForceEvaluatorUploadToTpInstanceWindowDescription';
import ForceEvaluatorUploadToTpInstanceItem from './ForceEvaluatorUploadToTpInstanceItem';

class EvaluatorAdmin extends React.Component {
  static defaultProps = {};

  thereWasRealSearch = false;

  constructor(props) {
    super(props);

    EvaluatorItem.editFunction = (id, evaluator, evaluatorList) => this.editFunction(id, evaluator, evaluatorList);
    EvaluatorItem.forceUploadToTpInstanceFunction = (id, evaluator, evaluatorList) =>
      this.forceUploadToTpInstanceFunction(id, evaluator, evaluatorList);
    EvaluatorItem.tipaltiEditReviewFunction = this.tipaltiEditReviewFunction.bind(this);
    EvaluatorItem.assigmentsFunction = this.assigmentsFunction.bind(this);
    EvaluatorItem.evaluatorPaymentsFunction = this.evaluatorPaymentsFunction.bind(this);

    const searchItem = new EvaluatorSearchParams();

    // Deep-link seed for global record search (CD-5425). content.js renders a deep-linked page with no
    // props, so the URL is the only channel. The office filters must be cleared alongside the name:
    // EvaluatorSearchParams defaults them to the caller's own offices, while the palette applies no
    // office scoping, so an evaluator from another office would arrive here and be filtered straight
    // back out - the user clicks a result and lands on an empty grid.
    const seededName = new URLSearchParams(window.location.search).get('Name');
    if (seededName) {
      searchItem.Name = seededName;
      searchItem.FieldworkOfficeIds = [];
      searchItem.PaymentOfficeIds = [];
    }

    this.state = {
      shownPanel: ShownPanelsEnum.Search,
      searchItem,
      orderDirection: 'Asc',
      selected: -1,
      selectedEvaluator: null,
      shownOverWindow: ShownOverWindowsEnum.None,
      tipaltiEvaluator: null,
      evaluatorList: [],
      // A production build opens the grid empty until the user searches, except for a deep link, which
      // already carries its search (CD-5425) and would otherwise wait for a Search click.
      cleared: process.env.NODE_ENV !== 'development' && !searchItem.Id && !seededName,
      itemType: EvaluatorItem,
    };
    this.showPanel = this.showPanel.bind(this);
    this.startSearch = this.startSearch.bind(this);
    this.closeOverWindow = this.closeOverWindow.bind(this);
    this.afterEvaluatorSaved = this.afterEvaluatorSaved.bind(this);
    this.lastEditedEvaluator = null;
  }

  assigmentsFunction(id, evaluator) {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.AssignmentsList,
      tipaltiEvaluator: evaluator,
    });
  }

  evaluatorPaymentsFunction(evaluator) {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.EvaluatorPayments,
      tipaltiEvaluator: evaluator,
    });
  }

  tipaltiEditReviewFunction(id, evaluator, evaluatorList) {
    this.setState({
      shownOverWindow: ShownOverWindowsEnum.TipaltiEvaluatorData,
      tipaltiEvaluator: evaluator,
    });
  }

  isEqual = (...objects) => objects.every((obj) => JSON.stringify(obj) === JSON.stringify(objects[0]));

  startSearch(searchItem) {
    this.setState({
      searchItem,
      cleared: false,
    });
  }

  afterEvaluatorSaved() {
    const editedEvaluator = this.lastEditedEvaluator;
    this.setState({ shownPanel: ShownPanelsEnum.None });

    if (!editedEvaluator) {
      this.refresh();
      return;
    }

    const searchItemNew = new EvaluatorSearchParams();
    searchItemNew.Id = editedEvaluator.EvId;
    searchItemNew.Name = `${editedEvaluator.EvFirstName} ${editedEvaluator.EvLastName}`;
    this.setState({
      searchItem: searchItemNew,
      cleared: false,
    });
  }

  editFunction(id, evaluator, evaluatorList) {
    this.lastEditedEvaluator = evaluator;
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selected: id,
      selectedEvaluator: evaluator,
    });
  }

  forceUploadToTpInstanceFunction(id, evaluator, evaluatorList) {
    this.setState({
      shownPanel: ShownPanelsEnum.ForceUploadToTpInstance,
      selected: id,
      selectedEvaluator: evaluator,
    });
  }

  showPanel(panelId) {
    panelId = panelId === this.state.shownPanel ? ShownPanelsEnum.None : panelId;
    this.setState({ shownPanel: panelId });
  }

  closeOverWindow() {
    this.setState({ shownOverWindow: ShownOverWindowsEnum.None });
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedEvaluator}
            clickOnCancel={() => {
              this.setState({ shownPanel: ShownPanelsEnum.None });
            }}
            clickOnSave={this.afterEvaluatorSaved}
            onChangeEditedItem={(edited) => {
              this.lastEditedEvaluator = edited;
            }}
            windowDescription={EvaluatorWindowDescription}
            errorCode='EA136'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.ForceUploadToTpInstance,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={new ForceEvaluatorUploadToTpInstanceItem(this.state.selectedEvaluator, null)}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            windowDescription={ForceEvaluatorUploadToTpInstanceWindowDescription}
            errorCode='FEUTI155'
          />
        )}
      </div>
    );
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderOverWindows() {
    if (this.state.shownOverWindow === ShownOverWindowsEnum.TipaltiEvaluatorData) {
      return (
        <ShowTipaltiEvaluatorDataWindow
          evaluator={this.state.tipaltiEvaluator}
          clickOnCancel={this.closeOverWindow}
        />
      );
    } else if (this.state.shownOverWindow === ShownOverWindowsEnum.AssignmentsList) {
      return (
        <ShowAssignmentListOverDataWindow
          evaluator={this.state.tipaltiEvaluator}
          clickOnCancel={this.closeOverWindow}
        />
      );
    } else if (this.state.shownOverWindow === ShownOverWindowsEnum.EvaluatorPayments) {
      return (
        <ShowEvaluatorPaymentsOverDataWindow
          evaluator={this.state.tipaltiEvaluator}
          clickOnCancel={this.closeOverWindow}
        />
      );
    }

    return null;
  }

  refresh() {
    this.setState({
      searchItem: { ...this.state.searchItem },
      cleared: false,
    });
  }

  editPanelOnClose(refresh) {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    if (refresh) {
      this.refresh();
    }
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderPanels()}
        <TabOfDataTable
          type={this.state.itemType}
          shownPanel={this.state.shownPanel}
          serviceFunction={EvaluatorService.GetEvaluatorList}
          convertDBItemsFunction={EvaluatorService.ConvertDBEvaluator}
          searchParamsType={EvaluatorSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          cleared={this.state.cleared}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in different id, name or email...'
          errorCode='EA207'
        />
        {this.renderOverWindows()}
      </div>
    );
  }
}

export default EvaluatorAdmin;
